<template>
    <dm-modal v-if="show"
              v-on:close="$emit('close')"
              v-bind:show="show">
        <div class="dmv-coupon-modal" slot="content">
            <div class="dmv-coupon-modal-content">
                <div v-if="model">
                    <div v-if="!more">
                        <div class="dmv-coupon-modal-content__text">
                            <h4 class="hd hd--thumb">{{model.valuePrefix}} <strong>{{model.shortValue}}</strong> w sklepie:</h4>
                            <div class="_tac"><strong>{{model.shopName}}</strong></div>
                        </div>
                        <div class="dmv-coupon-modal-content__text">
                            {{model.shortDescription}}
                        </div>
                        <div class="dmv-coupon-modal-content__info">
                            <span>{{model.remain}}</span>
                            <span v-on:click="handleClickConditions" class="dmv-coupon-modal-content__conditions"> Warunki kodu &raquo;</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="dmv-coupon-modal-content__text">
                            <h4 class="hd hd--thumb">
                                <a href="#" v-on:click.prevent="handleClickConditions" class="dmv-coupon-modal-content__icon">
                                    <dm-icon name="arrow-left" :width="20" :height="20" />
                                </a>
                                Warunki i sposób realizacji
                            </h4>
                            <ol class="dmv-coupon-modal-conditions-list">
                                <li v-for="item in model.conditions">{{item}}</li>
                            </ol>
                        </div>
                    </div>
                    <dm-coupon-button :code="model.code" v-on:copy="$emit('copy')">
                        <div class="dmv-coupon-button">
                            <span class="dmv-coupon-button__message">Twój kod: <strong>{{model.code}}</strong></span>
                            <a :href="model.url" target="_blank" class="dmv-coupon-button__label" title="Kopiuj i przejdź do sklepu">
                                Kopiuj i przejdź do sklepu &rarr;
                            </a>
                        </div>
                    </dm-coupon-button>
                </div>
                <div v-else class="dmv-coupon-modal-content__loader">
                    <dm-page-preloader :isLoading="!model" :isStatic="true" />
                </div>
            </div>
            <ol class="list dmv-coupon-modal-steps" slot="footer">
                <li class="dmv-coupon-modal-steps__item">
                    <dm-icon class="dmv-coupon-modal-steps__icon" name="copy" :width="24" :height="24" />
                    <div>
                        <strong>1. Skopiuj kod</strong> i przejdź do sklepu
                    </div>
                </li>
                <li class="dmv-coupon-modal-steps__item">
                    <dm-icon class="dmv-coupon-modal-steps__icon" name="shirt" :width="24" :height="24" />
                    <div>
                        <strong>2. Dodaj produkty </strong> do koszyka
                    </div>
                </li>
                <li class="dmv-coupon-modal-steps__item">
                    <dm-icon class="dmv-coupon-modal-steps__icon" name="cart" :width="24" :height="24" />
                    <div>
                        <strong>3. Wpisz kod </strong> podczas składania zamówienia
                    </div>
                </li>
            </ol>
        </div>
    </dm-modal>
</template>
<script>
    import ModalCompontent from '../shared/modal-component.vue';
    import CouponButtonCompontent from './coupon-button-component.vue';
    import IconComponent from '../shared/icon-component.vue';
    import PagePreloader from '../shared/page-preloader-component.vue';

    export default {
        name: 'dm-coupon-modal',
        components: {
            'dm-modal': ModalCompontent,
            'dm-coupon-button': CouponButtonCompontent,
            'dm-icon': IconComponent,
            'dm-page-preloader': PagePreloader,
        },
        data() {
            return {
                more: false
            };
        },
        updated() {
            this.more = this.show ? this.more : false;
        },
        methods: {
            handleClickConditions() {
                this.more = !this.more;
                this.$emit('more', this.more);
            }
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            model: {
                type: Object
            }
        }
    };
</script>
